<template>
    <page-loading v-if="loading"></page-loading>
    <form-container v-else>
        <page-header v-if="props.phoneNumberPoolId" class="mb-6 lg:mb-12">
            <template v-slot:subtitle>
                <a
                    :href="`/settings/teams/${teamId}#/phone-number-pools`"
                    class="no-underline! text-sky-600! text-base font-normal"
                >
                    <font-awesome-icon widthAuto class="mr-1" :icon="faArrowLeft"></font-awesome-icon>
                    All Phone Pools
                </a>
            </template>

            <slot name="header">{{ phoneNumberPool.friendly_name }}</slot>
        </page-header>

        <div
            :class="{
                'grid grid-cols-12 items-start': props.phoneNumberPoolId,
            }"
        >
            <page-sidebar
                v-if="props.phoneNumberPoolId"
                :links="[
                    {
                        href: `/settings/teams/${teamId}/phone-number-pools/${props.phoneNumberPoolId}`,
                        label: 'Details',
                    },
                    {
                        href: `/settings/teams/${teamId}/phone-number-pools/${props.phoneNumberPoolId}/phone-numbers`,
                        label: 'Phone Numbers',
                    },
                ]"
            ></page-sidebar>
            <slot></slot>
        </div>
    </form-container>
</template>

<script setup>
import FormContainer from '~/components/general/FormContainer.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import PageHeader from '~/components/general/PageHeader.vue';
import { onMounted } from 'vue';
import { usePhoneNumberPoolDetails } from '~/components/settings/teams/phone-number-pools/usePhoneNumberPoolDetails';
import PageSidebar from '~/components/general/PageSidebar.vue';

const props = defineProps({
    phoneNumberPoolId: {
        type: Number,
        required: false,
    },
});

const teamId = Spark.state.currentTeam.id;
const { phoneNumberPool, loading, mount } = usePhoneNumberPoolDetails();

onMounted(() => {
    mount(props.phoneNumberPoolId);
});
</script>
